import { EBaseApiTags } from 'shared/typings';

import { enhancedApi } from './codegen.api';

export const clientApi = enhancedApi.enhanceEndpoints({
	addTagTypes: [
		EBaseApiTags.TASK,
	],
	endpoints: {
		publicOffersRetrieve: {
			providesTags: [EBaseApiTags.TASK],
		},
	},
});
export const {
	usePublicOffersRetrieveQuery,
} = clientApi;
